var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3471 16.1623C19.86 14.0978 20.5377 11.5381 20.2444 8.99535C19.9512 6.45263 18.7086 4.1144 16.7654 2.44845C14.8222 0.782495 12.3217 -0.0883134 9.76399 0.0102384C7.20631 0.10879 4.78016 1.16943 2.97091 2.97997C1.16167 4.79051 0.102761 7.21742 0.0060395 9.77517C-0.0906821 12.3329 0.781915 14.8329 2.44926 16.7749C4.1166 18.7169 6.45572 19.9577 8.99865 20.2492C11.5416 20.5406 14.1008 19.8611 16.1642 18.3467H16.1627C16.2096 18.4092 16.2596 18.4686 16.3158 18.5264L22.3314 24.542C22.6244 24.8352 23.0219 25 23.4363 25.0001C23.8508 25.0003 24.2484 24.8358 24.5416 24.5428C24.8348 24.2498 24.9996 23.8523 24.9997 23.4379C24.9999 23.0234 24.8354 22.6258 24.5424 22.3326L18.5267 16.317C18.4709 16.2604 18.4108 16.2098 18.3471 16.1623ZM18.7502 10.1561C18.7502 11.2846 18.5279 12.4021 18.096 13.4447C17.6641 14.4874 17.0311 15.4348 16.2331 16.2328C15.4351 17.0308 14.4878 17.6638 13.4451 18.0956C12.4025 18.5275 11.285 18.7498 10.1564 18.7498C9.02788 18.7498 7.91039 18.5275 6.86775 18.0956C5.8251 17.6638 4.87774 17.0308 4.07973 16.2328C3.28173 15.4348 2.64872 14.4874 2.21684 13.4447C1.78497 12.4021 1.56268 11.2846 1.56268 10.1561C1.56268 7.87685 2.46809 5.691 4.07973 4.07936C5.69137 2.46772 7.87723 1.56231 10.1564 1.56231C12.4356 1.56231 14.6215 2.46772 16.2331 4.07936C17.8448 5.691 18.7502 7.87685 18.7502 10.1561Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e7c4635180ab388cd8d39ae2249235e3.svg";
export { ForwardRef as ReactComponent };